<app-section-outline-block
  [isShowFloatingTitle]="false"
  className="m-0"
  [headerTitle]="isShowHeaderTitle ? 'LABELS.UPLOAD_ISF_INSTRUCTION_SHEET' : ''"
  theme="highlighted"
>
  <ng-container section-header-actions>
    <div class="app-isf-documents-box__header__actions-group">
      <button
        class="app-es-documents-bl-box__header__actions__download-all-files-btn btn btn-link d-block"
        type="button"
        *ngIf="isShowDownloadAllDocs"
        (click)="onDownloadAllFiles()"
      >
        <img src="assets/icons/icon_download_sm_blue.svg" alt="download" />
        <span>
          {{ "LABELS.DOWNLOAD_ALL_FILES" | translate }}
        </span>
      </button>

      <div class="btn-group app-isf-documents-box__header__actions__add-documents d-print-none" dropdown>
        <button id="button-files" dropdownToggle type="button" class="btn btn-link dropdown-toggle">
          <span class="wrapper-icon-add"><i class="fa fa-plus"></i></span>
          <span>{{ "BUTTON.ADD_OTHER_DOCUMENT" | translate }}</span>
          <span class="wrapper-icon-carret"><i class="fa fa-chevron-down"></i></span>
        </button>
        <ul id="dropdown-files" class="dropdown-menu" role="menu" *dropdownMenu>
          <li role="menuitem" *ngFor="let doc of additionalDocumentsOptions" (click)="onAddOtherDocument(doc)">
            <span class="dropdown-item">
              {{ "ENTRY_SUMMARY.BILL_OF_LADING_DOCS." + enumDocumentType[doc] + ".TITLE" | translate }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>

  <ng-container *ngFor="let doc of isfDocuments">
    <document-upload-desktop
      [id]="'isf-doc-' + isf?.id + '-' + doc.type + '-' + doc.id"
      [uploadedDocument]="document(doc)"
      [attachmentName]="documentName(doc, index + 1)"
      [attachmentHint]="documentHint(doc.type)"
      [isLoading]="!!isLoadingDocUploadFlags && isLoadingDocUploadFlags.get(doc.type + '-' + isf?.id + '-' + doc.id)"
      [isShowLoader]="!isLoadingDocUploadFlags"
      [isSimpleStripLayout]="true"
      [isFullErrorHighlight]="true"
      [isShowOptionalTag]="false"
      [isHideTag]="true"
      [canRemoveDocuments]="isShowDeleteDocument"
      [canViewDocuments]="true"
      [canDownloadDocuments]="true"
      [canUploadDocuments]="true"
      [isShowLabelOverUploadedDate]="true"
      (upload)="onUploadDocument($event, doc)"
      (preview)="onPreviewDocument($event)"
      (remove)="onDeleteDocument($event)"
      (stateUpdate)="onUpdateDocumentState($event, doc)"
    ></document-upload-desktop>
  </ng-container>

  <ng-container *ngFor="let doc of visibleLocalAdditionalDocuments">
    <document-upload-desktop
      [id]="'isf-doc-additional-' + isf?.id + '-' + doc.type + '-' + doc.id"
      [uploadedDocument]="doc"
      [attachmentName]="additionalDocumentName(doc)"
      [attachmentHint]="documentHint(doc.type)"
      [isLoading]="doc.id === loadingLocalDocId"
      [isSimpleStripLayout]="true"
      [isFullErrorHighlight]="true"
      [isHideTag]="true"
      [isRequired]="false"
      [canRemoveDocuments]="true"
      [canUploadDocuments]="true"
      [isShowLabelOverUploadedDate]="true"
      (upload)="onUploadAdditionalDocument($event, doc)"
      (remove)="onRemoveAdditionalSlot(doc)"
    ></document-upload-desktop>
  </ng-container>

  <div *ngIf="isShowSkipOcrScanControl" section-footer class="custom-control custom-checkbox pl-4 pt-2">
    <input type="checkbox" [formControl]="skipOcrScanControl" class="custom-control-input" [id]="'skipOCRCheckbox-' + index" />
    <label class="custom-control-label" [for]="'skipOCRCheckbox-' + index">
      {{ "UPLOAD_ISF_DOCS_WITHOUT_SCANNING" | translate }}
    </label>
  </div>
</app-section-outline-block>
